(ns com.theplantscape.plant-web.components.tailwind.forms.diagram-setup
  (:require
   [clojure.string :as str]
   [com.theplantscape.local-store.ensemble :refer [fetch-diagram-version]]
   [com.theplantscape.plant-web.components.forms.core
    :refer [update-atom-ns-hm]]
   [com.theplantscape.plant-web.components.tailwind.map-open-layers
    :refer [ui-map]]
   [com.theplantscape.plant-web.draw.state
    :refer [compass-rotation site-state]]
   [com.theplantscape.plant-web.components.tailwind.buttons
    :refer [button-progress-async]]
   [com.theplantscape.plant-web.draw.ui-form :as form]
   [com.theplantscape.plant-web.api.diagrams :as d]

   [com.theplantscape.plant-web.components.forms.core :refer [update-atom-hm]]
   [com.theplantscape.plant-web.components.tailwind.buttons :refer [button]]

   [com.theplantscape.web-ui.tailwind.ensemble :as fi]
   [com.theplantscape.web-ui.tailwind.form.elements.input :as f]
   [reagent.core :as r]))


#_(defn ui-form-create-diagram [cfg]
  (let [values (r/atom {:values {:diagram|title "My Garden"}})
        form (partial update-atom-hm values)]
    (fn []
      [:div ;.flex.flex-wrap
       [form/ui-input-inline-fn
        "diagram|title"
        {:label "Create Diagram"
         :label-classes "m-2"
         :input-classes "m-2"
         :default-value-fn (-> @values :values :diagram|title)
         :on-change-fn form}]

       [:div.mt-4
        [button-progress-async
         "Add"
         {:on-click (fn [] ((:on-submit cfg) @values) )  
          :on-complete (:on-submit-complete cfg)}]]
       ])))

(defn diagram-setup-form [title values cfg]
  (let [form-state (r/atom {:disabled false
                            :mode :login})
        form (partial update-atom-ns-hm :diagram.settings values)
        on-submit (fn [e]
                    (prn "Save diagram settings")
                    (.preventDefault e)
                    (prn (:on-submit cfg))
                    ((:on-submit cfg) (:values @values))
                    ((:close-fn cfg)))]
    (fn [title values cfg]
      [:div.w-full.flex.justify-center {:style {:class "bg-gray-100"}}
       [:div.bg-white.p-4.xs:p-0.mx-auto
        {:style {:z-index 999} :class "w-1/2"}
        (when (-> @form-state :disabled)
          [:svg.animate-spin.-ml-1.mr-3.h-6.w-6.text-black
           {:xmlns "http://www.w3.org/2000/svg" :fill "none" :viewBox "0 0 24 24"}
           [:circle.opacity-25 {:cx "12" :cy "12" :r "10" :stroke "#000000" :stroke-width "4"}]
           [:path.opacity-75 {:fill "#000000" :d "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"}]])

        [:div.bg-white.shadow.w-full.rounded-lg.divide-y.divide-gray-200
         [:div.px-5.py-7
          [:h1.font-bold.text-center.text-2xl.mb-5 title]
          [:div (str "v" (fetch-diagram-version))]
          ;;[:div.font-small (str @values)]
          [:form {:on-submit on-submit}
           [f/ui-form-input
            (r/cursor values [:values :diagram.settings/title])
            {:name "title" :label "Design title"
             :tooltip "Title of your design"
             :placeholder "Design title" :store-fn form}]

           #_[f/ui-form-input
            (r/cursor values [:values :diagram.settings/longitude])
            {:name "longitude" :label "Longitude"
             :tooltip "Map location"
             :placeholder "-0.09" :store-fn form}]

           #_[f/ui-form-input
            (r/cursor values [:values :diagram.settings/latitude])
            {:name "latitude" :label "Latitude"
             :tooltip "Map location"
             :placeholder "51.505" :store-fn form}]

           [f/ui-form-input
            (r/cursor values [:values :diagram.settings/orientation])
            {:name "orientation" :label "Orientation"
             :tooltip "Orientation in degrees"
             :placeholder "25" :store-fn form}]

           [f/ui-gps-coordinates
            (or (r/cursor values [:values :diagram.settings/geo-location]) [50 50])
            {:name "location" :label "Longitude / Latitude"
             :tooltip "Map location"
             :placeholder "51.505"
             :store-fn form
             :get-location-fn (fn [] (prn "geo location fn") (:location @site-state))}]

           [fi/ui-form-checkbox
            (r/cursor values [:values :diagram.settings/public])
            {:name "public"
             :label "Available to everyone"
             :placeholder "true"
             :tooltip "Available to everyone"
             :default true}]

           [f/ui-form-input
            (r/cursor values [:values :diagram.settings/width])
            {:name "width" :label "Width"
             :tooltip "Design limits"
             :placeholder "100" :store-fn form}]

           [f/ui-form-input
            (r/cursor values [:values :diagram.settings/height])
            {:name "height" :label "Height"
             :placeholder "100" :store-fn form}]

           [:button.mb-4.transition.duration-200.bg-blue-500.hover:bg-blue-600.focus:bg-blue-700.focus:shadow-sm.focus:ring-4.focus:ring-blue-500.focus:ring-opacity-50.text-white.py-2.5.rounded-lg.text-sm.shadow-sm.hover:shadow-md.font-semibold.text-center {:class "w-1/3" :type "submit" :disabled (-> @form-state :disabled)}  "Save"]
           [:button.ml-4.transition.duration-200.bg-blue-500.hover:bg-blue-600.focus:bg-blue-700.focus:shadow-sm.focus:ring-4.focus:ring-blue-500.focus:ring-opacity-50.text-white.w-half.py-2.5.rounded-lg.text-sm.shadow-sm.hover:shadow-md.font-semibold.text-center {:class "w-1/3" :type "reset" :on-click (:close-fn cfg)} "Close"]]]]]
       [:div {:class "w-1/2"}
        (prn "ui map")
        [ui-map
         (-> @values :values :diagram.settings/geo-location )
         (compass-rotation)
         values]]])))


